import { ICall } from "interfaces/ICall"
import ISchedulingDate from "interfaces/ISchedulingDate";
import { getLastCallData, getSchedules, makeRedialCall, makeSchedulingCall, saveDynamicFields, saveTabbing, unPauseQueue } from "services/attendant"
import { SocketStore } from "store/socket";
import { UserStore } from "store/user";
import { setUserStatus } from "store/user/actions";
import { callReceivedBySocket } from "utils/asterisk";
import { StatusConstants } from "utils/constants";
import sweetAlert from "utils/sweetAlert";
import { setIsOnPauseQueue } from 'store/user/actions';
import { setAttendantPause } from "components/RightPanel/PlayContainer/helper";
import { setActualAudit, setApproached, setCallCreated, setCallType, setInPause, setSipCallData } from "store/call/actions";
import { closeScheduleModal, setActualModal } from "utils/popups";
import { setActualCall, setCallWithoutTabbing } from "store/socket/actions,";
import SchedulesModal from "components/SchedulesModal";
import React from "react";
import { CallStore } from "store/call";
import { saveAuditStatus } from "services/audits";

interface IFinalizeCallTab {
  tabbingStatus: string;
  callData?: ICall;
  observations: string;
}

export const finalizeCallTab = async ({
  tabbingStatus,
  observations,
  } : IFinalizeCallTab) => {
  try {
    const actualAudit = CallStore.getRawState().actualAudit;

    if (!tabbingStatus) return;

    if (!actualAudit.status) return;

    let callData = CallStore.getRawState().callCreated;
    const callType = CallStore.getRawState().type;

    let callApproached = SocketStore.getRawState().actualCall;

    if (!callData?._id && callType === 'FILA') {
      sweetAlert.error("Registro da ligação não criado! Contate o suporte.");
      return;
    }

    if (!callData?._id && callType === 'REDISCAGEM') {
      callData = await getLastCallData();
    }

    if(callApproached?._id) {
      await saveDynamicFields(
        callApproached?.client._id,
        callApproached?._id,
        callApproached?.user._id,
        callApproached?.lead._id,
        JSON.parse(sessionStorage.getItem('dynamicFields') || '[]')
      );
    }

    await saveTabbing(tabbingStatus, callData, observations);
    await saveAuditStatus(actualAudit._id, actualAudit.status);

    setCallCreated(undefined);
    if (!!SocketStore.getRawState().callWithoutTabbing) {
      window.location.reload();
      return;
    }

    const pauseQueue = UserStore.getRawState().pauseQueue;

    if (pauseQueue.isOnPauseQueue) {
      setInPause(true);
      setAttendantPause(pauseQueue.pauseReason);
      setUserStatus(StatusConstants.PAUSED);
      setIsOnPauseQueue(false, "");

      return;
    }

    const schedulingResponse = await getSchedules();

    if (schedulingResponse.length > 0) {
      setActualModal(React.createElement(SchedulesModal, { schedules: schedulingResponse }, null), true, "50%", closeScheduleModal);
    } else {
      setCallType('FILA');
      setSipCallData(undefined);
      setUserStatus(StatusConstants.WAITING);
      setTimeout(() => {
        unPauseQueue();
        console.log('Atendente Devolvido a Fila.');
      }, 5000);
    }

    setApproached(false);
    setActualCall(undefined);
    setCallWithoutTabbing(undefined);
    setActualAudit(undefined);
  } catch {
    // sweetAlert.error("Ocorreu um erro ao tabular");
  }
}

export const redialCallTab = async (observations: string) => {
  try {
    const tabbingStatus = {
      label: 'Rediscar',
      status: 'Rediscar',
      type: 'rediscar',
    }
    setCallType('REDISCAGEM');

    let callData = SocketStore.getRawState().actualCall;

    if (!callData) {
      callData = await getLastCallData();
    }

    if(callData?._id) {
      await saveDynamicFields(
        callData?.client._id,
        callData?._id,
        callData?.user._id,
        callData?.lead._id,
        JSON.parse(sessionStorage.getItem('dynamicFields') || '[]')
      );
    }
    setUserStatus(StatusConstants.ATTENDANCE);
    setApproached(false);
    setCallCreated(undefined);
    setActualCall(undefined);
    setCallWithoutTabbing(undefined);
    await makeRedialCall(tabbingStatus, callData._id, observations);
    callReceivedBySocket(callData);
  } catch {
    // sweetAlert.error("Ocorreu um erro ao rediscar");
  }
}

export const schedulingCallTab = async (
  schedulingDate: ISchedulingDate,
  observations: string,
  tabbingStatusSelected: any,
  ) => {
  try {
    let callApproached = SocketStore.getRawState().actualCall;

    const tabbingStatus = {
      label: tabbingStatusSelected?.label,
      status: tabbingStatusSelected?.status,
      type: tabbingStatusSelected?.type,
    }

    if (!tabbingStatusSelected.label || !tabbingStatusSelected.status) {
      tabbingStatus.label = "Agendamento Pessoal";
      tabbingStatus.status = "Agendamento Pessoal";
    }

    if (!tabbingStatus.type) {
      tabbingStatus.type = "ag-pessoal";
    }

    let callData = CallStore.getRawState().callCreated;
    const callType = CallStore.getRawState().type;

    if (!callData?._id && callType === 'FILA') {
      sweetAlert.error("Registro da ligação não criado! Contate o suporte.");
      return;
    }

    if (!callData?._id && callType === 'REDISCAGEM') {
      if (CallStore.getRawState().approached) {
        callData = SocketStore.getRawState().actualCall;
      } else {
        callData = await getLastCallData();
      }
    }

    if(callApproached?._id) {
      await saveDynamicFields(
        callApproached?.client._id,
        callApproached?._id,
        callApproached?.user._id,
        callApproached?.lead._id,
        JSON.parse(sessionStorage.getItem('dynamicFields') || '[]')
      );
    }

    await makeSchedulingCall(tabbingStatus, schedulingDate, callData, observations);

    if (!!SocketStore.getRawState().callWithoutTabbing) {
      window.location.reload();
      return;
    }

    const pauseQueue = UserStore.getRawState().pauseQueue;

    if (pauseQueue.isOnPauseQueue) {
      setUserStatus(StatusConstants.PAUSED);
      setAttendantPause(pauseQueue.pauseReason);
      setIsOnPauseQueue(false, "");
      setInPause(true);

      return;
    }

    const schedulingResponse = await getSchedules();

    if (schedulingResponse.length > 0) {
      setActualModal(React.createElement(SchedulesModal, { schedules: schedulingResponse }, null), true, "50%", closeScheduleModal);
    } else {
      setUserStatus(StatusConstants.WAITING);
      setTimeout(() => {
        unPauseQueue();
        console.log('Atendente Devolvido a Fila.');
      }, 5000);
    }

    setApproached(false);
    setActualCall(undefined);
    setCallWithoutTabbing(undefined);
    setActualAudit(undefined);
  } catch {
    // sweetAlert.error("Ocorreu um erro ao agendar");
  }
}
